import CountUp from "react-countup";

function SectionCounter1() {
    return (
        <div
            className="counter-blocks flex items-center justify-center"
            style={{ padding: "40px 0" }}
        >
            <div className="row when-item-four w-full max-w-[1200px] mx-0">
                {[ // This helps reduce repeated code.
                    { count: 95, label: "Our Active Member" },
                    { count: 140, label: "Our Total Project" },
                    { count: 10, label: "Our Winning Award" },
                    { count: 30, label: "Our Team Member" }
                ].map((item, idx) => (
                    <div key={idx} className="col-xl-3 col-lg-3 col-md-6 col-sm-6 p-4">
                        <div className="x-count shadow-lg rounded-xl bg-white py-4 px-4  text-center hover:scale-105 transition-transform duration-300 ease-in-out">
                            <h2 className="x-title text-4xl font-bold text-[#fd4c7d]">
                                
                                <span className="counter">
                                    <CountUp end={item.count} duration={4} />
                                </span>
                                <span className="x-cont-before text-2xl">+</span>
                            </h2>
                            <div className="x-count-info mt-2 text-gray-700 font-semibold text-lg">{item.label}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default SectionCounter1;
